export default __webpack_public_path__ + "9eb1fab2684d1e1f0e260b08dde626cf.svg";